import { render, staticRenderFns } from "./TranProgramModuleCreateDetail.vue?vue&type=template&id=f1d0e5aa"
import script from "./TranProgramModuleCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranProgramModuleCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranProgramModuleCreateDetail.vue?vue&type=style&index=0&id=f1d0e5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports